var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFreeContent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#free-content_svg__filter0_d_529_6804)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "free-content_svg__a",
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 5,
    width: 25,
    height: 25,
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4 4h20v20H4V4z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 9.371C14 6.848 16.15 4.8 18.8 4.8s4.8 2.048 4.8 4.571V11.6a.4.4 0 01-.4.4h-1.12a.4.4 0 01-.4-.4V9.371c0-1.518-1.286-2.742-2.88-2.742s-2.88 1.225-2.88 2.742V12H16a1.6 1.6 0 011.6 1.6v8c0 .888-.712 1.6-1.6 1.6H6.4a1.6 1.6 0 01-1.6-1.6v-8A1.6 1.6 0 016.4 12H14V9.371z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 9.371C14 6.848 16.15 4.8 18.8 4.8s4.8 2.048 4.8 4.571V11.6a.4.4 0 01-.4.4h-1.12a.4.4 0 01-.4-.4V9.371c0-1.518-1.286-2.742-2.88-2.742s-2.88 1.225-2.88 2.742V12H16a1.6 1.6 0 011.6 1.6v8c0 .888-.712 1.6-1.6 1.6H6.4a1.6 1.6 0 01-1.6-1.6v-8A1.6 1.6 0 016.4 12H14V9.371z",
    fill: "#fff",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.92 12h-.24v.24h.24V12zM14 12v.24h.24V12H14zm4.8-7.44c-2.771 0-5.04 2.144-5.04 4.811h.48c0-2.38 2.032-4.331 4.56-4.331v-.48zm5.04 4.811c0-2.666-2.269-4.811-5.04-4.811v.48c2.528 0 4.56 1.952 4.56 4.331h.48zm0 2.229V9.371h-.48V11.6h.48zm-.64.64a.64.64 0 00.64-.64h-.48a.16.16 0 01-.16.16v.48zm-1.12 0h1.12v-.48h-1.12v.48zm-.64-.64a.64.64 0 00.64.64v-.48a.16.16 0 01-.16-.16h-.48zm0-2.229V11.6h.48V9.371h-.48zM18.8 6.869c1.472 0 2.64 1.128 2.64 2.502h.48c0-1.661-1.405-2.982-3.12-2.982v.48zm-2.64 2.502c0-1.374 1.168-2.502 2.64-2.502v-.48c-1.715 0-3.12 1.322-3.12 2.982h.48zm0 2.629V9.371h-.48V12h.48zm-.16-.24h-.08v.48H16v-.48zm1.84 1.84A1.84 1.84 0 0016 11.76v.48a1.36 1.36 0 011.36 1.36h.48zm0 8v-8h-.48v8h.48zM16 23.44c1.021 0 1.84-.819 1.84-1.84h-.48c0 .755-.605 1.36-1.36 1.36v.48zm-9.6 0H16v-.48H6.4v.48zM4.56 21.6a1.84 1.84 0 001.84 1.84v-.48a1.36 1.36 0 01-1.36-1.36h-.48zm0-8v8h.48v-8h-.48zm1.84-1.84a1.84 1.84 0 00-1.84 1.84h.48a1.36 1.36 0 011.36-1.36v-.48zm7.6 0H6.4v.48H14v-.48zm-.24-2.389V12h.48V9.371h-.48z",
    fill: "#000",
    fillOpacity: 0.5,
    mask: "url(#free-content_svg__a)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "free-content_svg__filter0_d_529_6804",
    x: 0.7,
    y: 0.7,
    width: 34.1,
    height: 33.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_529_6804"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_529_6804",
    result: "shape"
  })))));
}
export default SvgFreeContent;